import { useState } from "react";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import styled from "styled-components";
import { createFaq } from "../../utils/api-calls";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  width: 500px;
  max-width: 90%;
`;

const ModalHeader = styled.h2`
  margin-top: 0;
  color: #333;
`;

const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormGroup = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 16px;
  min-height: 120px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

const ModalButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

const ModalButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background-color: ${props => props.primary ? "#1890ff" : "#f0f0f0"};
  color: ${props => props.primary ? "white" : "#333"};
  
  &:hover {
    background-color: ${props => props.primary ? "#40a9ff" : "#d9d9d9"};
  }
`;


// AddFaq Component
export const AddFaq = ({ close }) => {
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    name: "",
    body: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const { mutate: createFaqMutate } = useMutation(
    (data) => createFaq(data),
    {
      onSuccess: () => {
        toast.success('Faq created successfully');
        queryClient.invalidateQueries("all-faqs");
        close();
      },
      onError: () => {
        toast.error('Error creating FAQ');
      }
    }
  )

  const handleSubmit = async (e) => {
    e.preventDefault();

    createFaqMutate(formData);
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Add New FAQ</ModalHeader>
        <ModalForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="name">Question</Label>
            <Input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="body">Answer</Label>
            <TextArea
              id="body"
              name="body"
              value={formData.body}
              onChange={handleChange}
              required
            />
          </FormGroup>
          <ModalButtonGroup>
            <ModalButton type="button" onClick={close}>Cancel</ModalButton>
            <ModalButton type="submit" primary>Add FAQ</ModalButton>
          </ModalButtonGroup>
        </ModalForm>
      </ModalContent>
    </ModalOverlay>
  );
};
